import { type FC, useEffect } from 'react';
import { ConfigProvider, App as AntApp } from 'antd';
import { HelmetProvider } from 'react-helmet-async';
import { lightTheme, darkTheme } from '@/styles/theme';
import { useTheme } from '@/hooks/useTheme';
import { initGA } from '@/utils/analytics';
import { ContentProvider } from '@/context/ContentProvider';
import { AppRouter } from '@/router';
import '@/styles/global.css';

const Application: FC = () => {
  const { toggle, isDark } = useTheme();

  useEffect(() => {
    // Defer GA init to avoid blocking first paint
    const id = 'requestIdleCallback' in window
      ? requestIdleCallback(() => initGA())
      : setTimeout(() => initGA(), 3000);
    return () => {
      if ('requestIdleCallback' in window) cancelIdleCallback(id as number);
      else clearTimeout(id as ReturnType<typeof setTimeout>);
    };
  }, []);

  return (
    <HelmetProvider>
      <ConfigProvider theme={isDark ? darkTheme : lightTheme}>
        <AntApp>
          <ContentProvider>
            <AppRouter isDark={isDark} onToggleTheme={toggle} />
          </ContentProvider>
        </AntApp>
      </ConfigProvider>
    </HelmetProvider>
  );
};

export default Application;
